import {IFarmInputPurchaseOrder} from 'constants/interfaces';
import React, {useState} from 'react';
import {Box, Button, Card, Typography} from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import {_NumberWithSpaces} from 'constants/index';
import {Skeleton} from '@material-ui/lab';
import NavigationService from 'services/NavigationService';
import {apiConvertTaxInvoice} from 'constants/api/purchaseOrders';

export function InvoicePurchaseOrders(props: {
  invoiceId: any;
  isLoading?: boolean;
  purchaseOrders?: IFarmInputPurchaseOrder[];
  isTaxInvoice?: boolean;
  onCreatedTaxInvoice?: () => any;
}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={300} style={{borderRadius: 8}} />;
  if (!props.purchaseOrders) return null;
  return (
    <InvoicePurchaseOrdersTable
      invoiceId={props?.invoiceId}
      purchaseOrders={props.purchaseOrders}
      isTaxInvoice={props.isTaxInvoice}
      onCreatedTaxInvoice={() => {
        console.log("YOU're creating");
        props?.onCreatedTaxInvoice?.();
      }}
    />
  );
}

function InvoicePurchaseOrdersTable(props: {
  purchaseOrders?: IFarmInputPurchaseOrder[];
  isTaxInvoice?: boolean;
  invoiceId: any;
  onCreatedTaxInvoice?: () => any;
}) {
  const [isCreatingInvoice, setIsCreatingInvoice] = useState(false);
  const canCreateTaxInvoice = props?.purchaseOrders?.every(
    (it) => !!it?.supportingDocuments?.length,
  );
  const getSubline = () => {
    return !canCreateTaxInvoice
      ? 'All purchase orders should have supporting documents'
      : '';
  };
  const handleCreateTaxInvoice = () => {
    if (isCreatingInvoice) return;
    setIsCreatingInvoice(true);
    apiConvertTaxInvoice(props.invoiceId)
      .then(() => props?.onCreatedTaxInvoice?.())
      .finally(() => setIsCreatingInvoice(false));
  };
  return (
    <Card variant="outlined" className="invoice-products-table-container-2">
      <TableContainer className="invoice-products-table">
        <Table
          className="invoice-products-table"
          aria-label="order products table"
          size="small"
        >
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Supplier</TableCell>
              <TableCell align="right">Supporting&nbsp;Documents</TableCell>
              <TableCell align="right">Products</TableCell>
              <TableCell align="right">Total&nbsp;(R)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.purchaseOrders?.map(
              (order: IFarmInputPurchaseOrder, index: number) => (
                <TableRow
                  className="invoice-product-row"
                  key={order.id}
                  component={Box}
                  onClick={() =>
                    NavigationService.navigate(`/purchase-orders/${order.id}`)
                  }
                >
                  <TableCell className="invoice-product-name">
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      className="purchase-order-id"
                    >
                      KHUL-PO-{order?.id}
                    </Typography>
                  </TableCell>
                  <TableCell className="invoice-product-name">
                    <Typography variant="body2" color="textSecondary">
                      {order?.mainSupplier?.name}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" color="textSecondary">
                      {order?.supportingDocuments?.length ? 'Yes' : 'No'}
                    </Typography>
                  </TableCell>
                  <TableCell className="invoice-product-qty" align="right">
                    <Typography variant="body2" color="textSecondary">
                      {order?.orders?.length} item(s)
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" color="textSecondary">
                      {_NumberWithSpaces(order?.total)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ),
            )}
            {!props?.isTaxInvoice && (
              <TableRow className="footer">
                <TableCell colSpan={3} />
                <TableCell colSpan={2} align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!canCreateTaxInvoice}
                    onClick={handleCreateTaxInvoice}
                  >
                    {isCreatingInvoice
                      ? 'Creating invoice...'
                      : 'Create Tax Invoice'}
                  </Button>
                  <br />
                  {!canCreateTaxInvoice && (
                    <Typography variant="body2" style={{color: '#FF9800'}}>
                      {getSubline()}
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
